@let title = titleSg();
@let subtitle = subtitleSg();
@let color = colorSg();
@let logo = logoSg();
@let loadingMessage = loadingMessageSg();
@let noDelay = noDelaySg();

<div
  class="atn-splash-screen"
  [style.background]="
    color ? 'linear-gradient(135deg, ' + color + ' 0%, black 140%)' : undefined
  "
>
  <div
    class="atn-splash-screen__particles"
    data-test-id="splash-screen"
  >
    @for (particle of particlesSg(); track $index) {
      <div
        class="atn-splash-screen__particle"
        [style]="{
          animationDelay: particle.animationDelay + 's',
          animationDuration: particle.animationDuration + 's',
          left: particle.left + '%',
        }"
      ></div>
    }
  </div>

  <div class="atn-splash-screen__logo-container">
    <div
      class="atn-splash-screen__logo"
      [style.background]="color"
      [style.boxShadow]="color ? '0 20px 40px rgba(0, 0, 0, 0.3)' : undefined"
    >
      <img
        class="atn-splash-screen__logo-img"
        [src]="logo.src"
        [alt]="logo.alt"
      />
    </div>
  </div>

  <h1
    class="atn-splash-screen__company-name"
    [style.animationDelay]="noDelay ? '0s' : undefined"
  >
    {{ title }}
  </h1>
  @if (subtitle) {
    <p
      class="atn-splash-screen__tagline"
      [style.animationDelay]="noDelay ? '0s' : undefined"
    >
      {{ subtitle }}
    </p>
  }

  @if (loadingMessage) {
    <div class="atn-splash-screen__loading-container">
      <div class="atn-splash-screen__loading-bar">
        <div class="atn-splash-screen__loading-progress"></div>
      </div>
      <div class="atn-splash-screen__loading-text">
        {{ loadingMessageSg() }}
      </div>
    </div>
  }
</div>
